import { useEffect, useRef } from 'preact/hooks';
import { openSong } from './actions.js';
import { importLog, registerPickers } from './files.js';

/** The hidden file inputs: a song, and a saved count. They stay in the page so a sheet can close right after opening one. */
export function Pickers() {
  const song = useRef<HTMLInputElement>(null);
  const log = useRef<HTMLInputElement>(null);
  useEffect(() => registerPickers(song.current, log.current), []);
  return (
    <div hidden>
      <input
        type="file"
        accept="audio/*,.mp3,.m4a,.wav,.flac,.ogg,.aac"
        tabIndex={-1}
        aria-hidden="true"
        data-testid="song-input"
        ref={song}
        onChange={(e) => {
          const f = e.currentTarget.files?.[0];
          e.currentTarget.value = ''; // the same file can be chosen again
          if (f) void openSong(f);
        }}
      />
      <input
        type="file"
        accept="application/json,.json"
        tabIndex={-1}
        aria-hidden="true"
        data-testid="log-input"
        ref={log}
        onChange={(e) => {
          const f = e.currentTarget.files?.[0];
          e.currentTarget.value = '';
          if (f) void importLog(f);
        }}
      />
    </div>
  );
}
